<script>
    export let leadershipRoles = [];
</script>

<div class="container">
    <section class="announcements">
        <h2>Honors & Awards</h2>
        <ul>
            <li><a href="https://financialaid.umd.edu/resources-policies/presidents-scholarship-policy" class="no-style" target="_blank">UMD President's Scholarship (2024 to 2028)</a></li>
            <li><a href="https://www.goldmansachs.com/careers/students-and-graduates/programs/possibilities-summit.html" class="no-style" target="_blank">Goldman Sachs Possibilities Summit Fellow (2025)</a></li>
            <li><a href="https://www.isac.org/students/before-college/college-career-planning/state-scholar-program.html" class="no-style" target="_blank">Illinois State Scholar (2024)</a></li>
            <li><a href="https://adc.d211.org/site/Default.aspx?PageID=6614" class="no-style" target="_blank">Richard C Kolze Award (2024)</a></li>
            <li><a href="https://apstudents.collegeboard.org/awards-recognitions/ap-scholar-award" class="no-style" target="_blank">AP Scholar with Distinction (2023 and 2024)</a></li>
        </ul>    
    </section>
    
    <section class="opportunities">
        <h3>Programming Languages</h3>
        <ul class="skills-list">
            <li><a href="https://www.python.org/" class="no-style" target="_blank">Python</a></li>
            <li><a href="https://isocpp.org/" class="no-style" target="_blank">C++</a></li>
            <li><a href="https://en.cppreference.com/w/c" class="no-style" target="_blank">C</a></li>
            <li><a href="https://ocaml.org/" class="no-style" target="_blank">OCaml</a></li>
            <li><a href="https://www.rust-lang.org/" class="no-style" target="_blank">Rust</a></li>
            <li><a href="https://www.oracle.com/java/" class="no-style" target="_blank">Java</a></li>
            <li><a href="https://svelte.dev/" class="no-style" target="_blank">Svelte</a></li>
            <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" class="no-style" target="_blank">JavaScript</a></li>
            <li><a href="https://www.w3.org/standards/webdesign/htmlcss" class="no-style" target="_blank">HTML</a></li>
            <li><a href="https://www.w3.org/standards/webdesign/htmlcss" class="no-style" target="_blank">CSS</a></li>
            <li><a href="https://www.lua.org/" class="no-style" target="_blank">Lua</a></li>
        </ul>
    
        <h3>Frameworks & Tools</h3>
        <ul class="skills-list">
            <li><a href="https://www.docker.com/" class="no-style" target="_blank">Docker</a></li>
            <li><a href="https://git-scm.com/" class="no-style" target="_blank">Git</a></li>
            <li><a href="https://www.selenium.dev/" class="no-style" target="_blank">Selenium</a></li>
            <li><a href="https://www.mysql.com/" class="no-style" target="_blank">SQL</a></li>
            <li><a href="https://reactjs.org/" class="no-style" target="_blank">React.js</a></li>
            <li><a href="https://www.gnu.org/software/bash/" class="no-style" target="_blank">Shell Scripting</a></li>
            <li><a href="https://www.linux.com/" class="no-style" target="_blank">Linux</a></li>
            <li><a href="https://aws.amazon.com/" class="no-style" target="_blank">AWS</a></li>
            <li><a href="https://pandas.pydata.org/" class="no-style" target="_blank">pandas</a></li>
            <li><a href="https://numpy.org/" class="no-style" target="_blank">Numpy</a></li>
            <li><a href="https://plotly.com/" class="no-style" target="_blank">Plotly</a></li>
            <li><a href="https://seaborn.pydata.org/" class="no-style" target="_blank">Seaborn</a></li>
        </ul>
    </section>    
</div>

<style>
    .container {
        display: flex;
        justify-content: space-between;
        padding: 1.5rem;
        gap: 1.5rem;
        max-width: 1200px;
        margin: 0 auto;
    }

    .announcements, .opportunities {
        flex: 1;
        padding: 1.5rem;
        border-radius: 16px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        transition: all 0.3s ease;
    }

    .announcements:hover, .opportunities:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        border-color: rgba(100, 181, 246, 0.3);
    }

    .announcements {
        background: linear-gradient(135deg, rgba(100, 181, 246, 0.1) 0%, rgba(66, 165, 245, 0.1) 100%);
        border: 1px solid rgba(100, 181, 246, 0.2);
    }

    .opportunities {
        background: linear-gradient(135deg, rgba(66, 165, 245, 0.1) 0%, rgba(100, 181, 246, 0.1) 100%);
        border: 1px solid rgba(66, 165, 245, 0.2);
    }

    .announcements h2, .opportunities h3 {
        color: #ffffff;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        margin: 0 0 1rem 0;
        font-size: 1.5rem;
    }

    .opportunities h3 {
        font-size: 1.25rem;
        margin-bottom: 1rem;
    }

    .announcements ul, .opportunities ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .announcements li {
        padding: 0.5rem 0;
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 8px;
        margin-bottom: 0.25rem;
    }

    .announcements li:hover {
        background: rgba(100, 181, 246, 0.2);
        transform: translateX(4px);
    }

    .announcements li a {
        color: #e0e0e0;
        text-decoration: none;
        font-weight: 500;
        display: block;
        padding: 0.5rem;
    }

    .announcements li a:hover {
        color: #64b5f6;
    }

    .skills-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        list-style: none;
        padding: 0;
        margin: 0 0 1.5rem 0;
    }

    .skills-list li {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 20px;
        padding: 0.5rem 1rem;
        transition: all 0.3s ease;
        cursor: pointer;
    }

    .skills-list li:hover {
        background: rgba(100, 181, 246, 0.2);
        border-color: rgba(100, 181, 246, 0.4);
        transform: translateY(-2px);
    }

    .skills-list li a {
        color: #e0e0e0;
        text-decoration: none;
        font-weight: 500;
        font-size: 0.9rem;
    }

    .skills-list li a:hover {
        color: #64b5f6;
    }

    .coursework-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .coursework-list li {
        background: rgba(100, 181, 246, 0.1);
        border: 1px solid rgba(100, 181, 246, 0.3);
        border-radius: 20px;
        padding: 0.5rem 1rem;
        color: #e0e0e0;
        font-weight: 500;
        font-size: 0.9rem;
        transition: all 0.3s ease;
    }

    .coursework-list li:hover {
        background: rgba(100, 181, 246, 0.2);
        transform: translateY(-2px);
    }

    .no-style {
        color: inherit;
        text-decoration: none;
    }

    .no-style:hover {
        text-decoration: none;
    }

    @media only screen and (max-width: 768px) {
        .container {
            flex-direction: column;
            padding: 1rem;
            gap: 1rem;
        }

        .announcements, .opportunities {
            padding: 1.25rem;
        }

        .announcements h2, .opportunities h3 {
            font-size: 1.25rem;
        }

        .skills-list, .coursework-list {
            gap: 0.4rem;
        }

        .skills-list li, .coursework-list li {
            padding: 0.4rem 0.8rem;
            font-size: 0.85rem;
        }
    }
</style>
